const getDateParts = (value) => {
	if (!value) return null

	if (value instanceof Date) {
		if (Number.isNaN(value.getTime())) return null

		return {
			year: value.getFullYear(),
			month: value.getMonth() + 1,
			day: value.getDate(),
		}
	}

	const stringValue = String(value).trim()
	const apiDate = stringValue.match(/^(\d{4})[-.](\d{1,2})[-.](\d{1,2})$/)
	const displayDate = stringValue.match(/^(\d{1,2})[-.](\d{1,2})[-.](\d{4})$/)
	const match = apiDate ?? displayDate

	if (!match) return null

	const year = Number(apiDate ? match[1] : match[3])
	const month = Number(match[2])
	const day = Number(apiDate ? match[3] : match[1])
	const date = new Date(year, month - 1, day)

	if (
		date.getFullYear() !== year ||
		date.getMonth() !== month - 1 ||
		date.getDate() !== day
	) {
		return null
	}

	return { year, month, day }
}

export const getAgeFromBirthDate = (birthDate, currentDate = new Date()) => {
	const birthDateParts = getDateParts(birthDate)
	const currentDateParts = getDateParts(currentDate)

	if (!birthDateParts || !currentDateParts) return null

	let age = currentDateParts.year - birthDateParts.year
	const birthdayHasNotOccurred =
		currentDateParts.month < birthDateParts.month ||
		(currentDateParts.month === birthDateParts.month &&
			currentDateParts.day < birthDateParts.day)

	if (birthdayHasNotOccurred) age -= 1

	return age >= 0 ? age : null
}
